import { render, staticRenderFns } from "./collect-dialog.vue?vue&type=template&id=a2c633ba&scoped=true&"
import script from "./collect-dialog.vue?vue&type=script&lang=js&"
export * from "./collect-dialog.vue?vue&type=script&lang=js&"
import style0 from "./collect-dialog.vue?vue&type=style&index=0&id=a2c633ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c633ba",
  null
  
)

export default component.exports